var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',{staticClass:"currency-root-page"},[_c('app-tabs',{attrs:{"items":_vm.$options.tabItems,"current-route-name":_vm.$route.name}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }